import { Navigate, Route, Routes } from "react-router-dom";
import InsightsHub from "../features/insights/screens/InsightsHub";
import AdherenceScreen from "../features/insights/screens/AdherenceScreen";
import MuscleVolumeScreen from "../features/insights/screens/MuscleVolumeScreen";
import ExercisePerformanceScreen from "../features/insights/screens/ExercisePerformanceScreen";
import ExerciseDetailScreen from "../features/insights/screens/ExerciseDetailScreen";
import "../features/insights/insights.css";

/* Insights V1 (`/progress`): the Hub and its Adherence, Muscle Volume,
 * Exercise Performance and Exercise Detail screens (EP blueprint §6.1). */

export default function Progress() {
  return (
    <Routes>
      <Route index element={<InsightsHub />} />
      <Route path="adherence" element={<AdherenceScreen />} />
      <Route path="muscle-volume" element={<MuscleVolumeScreen />} />
      <Route path="exercise-performance" element={<ExercisePerformanceScreen />} />
      <Route path="exercise-performance/:exerciseId" element={<ExerciseDetailScreen />} />
      <Route path="*" element={<Navigate to="/progress" replace />} />
    </Routes>
  );
}
